var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "icon-layout" }, [
    _c("div", { staticClass: "layout-title" }, [
      _vm._v("*请选择 icon 样式模板"),
    ]),
    _c(
      "div",
      { staticClass: "layout-options" },
      _vm._l(_vm.form.icons, function (item) {
        return _c(
          "div",
          { key: item.id, staticClass: "layout-option" },
          [
            _c(
              "el-radio",
              {
                attrs: { label: item.id },
                on: {
                  change: function ($event) {
                    return _vm.handleLayoutChange(item.id)
                  },
                },
                model: {
                  value: _vm.form.layoutType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "layoutType", $$v)
                  },
                  expression: "form.layoutType",
                },
              },
              [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
            ),
            item.name.includes("单行")
              ? _c("div", { staticClass: "layout-preview" }, [
                  _c("div", { staticClass: "preview-title" }, [
                    _vm._v("样式预览:"),
                  ]),
                  _vm._m(0, true),
                ])
              : item.name.includes("多行")
              ? _c("div", { staticClass: "layout-preview" }, [
                  _c("div", { staticClass: "preview-title" }, [
                    _vm._v("样式预览:"),
                  ]),
                  _vm._m(1, true),
                ])
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preview-content single-row" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/iconLayout/icon_1.png") },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preview-content multi-row" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/iconLayout/icon_n.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }